<p-card>
  <app-loading-indicator [loading]="loading"></app-loading-indicator>
  <div class="p-grid">
    <div class="p-col-6 p-md-6 p-sm-6"><h3 [style]="{ fontWeight: '600' }">{{ 'ORDERS_BY_SUPPLIER' | translate}}</h3></div>
    <div class="p-col-6 p-md-6 p-sm-6">
      <p-button icon="pi pi-question" [style]="{marginLeft: '5px', float:'right'}"></p-button>
      <p-button icon="pi pi-arrow-down" [style]="{marginLeft: '5px', float:'right'}"></p-button>
    </div>
  </div>
      <form (ngSubmit)="load(null, null)">
        <div class="p-col-12" *ngIf="noSelected" [style]="{marginBottom:'10px'}">
          <p-message severity="error" text="{{ 'REQUIRED_FIELDS' | translate}}"><br></p-message>
        </div>
        <div class="p-grid">
          <div class="p-col-12 p-md-6 p-lg-3 p-input-icon-left">
                <i class="pi pi-search"></i>
            <p-autoComplete [style]="{width: '100%',border:'none', borderBottom: '2px solid #47bfd4'}"
                            appendTo="body" autofocus [suggestions]="variants" name="stock" placeholder="* {{ 'SEARCH_ITEM'| translate }}"
                            (completeMethod)="searchStock($event)" (onSelect)="onVariantSelect($event);" field="name">
            </p-autoComplete>
          </div>
          <div class="p-col-12 p-md-6 p-lg-3">
            <p-dropdown [style]="{width: '100%',border:'none', borderBottom: '2px solid #47bfd4'}"
                        [options]="searchContacts" [(ngModel)]="parameters.contact" (onChange)="parameters.contact = $event.value"
                        inputId="dropdownb" placeholder="{{ 'SELECT_SUPPLIER' | translate}}"  appendTo="body"
                        optionLabel="name" optionValue="id" [filter]="true" filterBy="name">
            </p-dropdown>
          </div>
          <div class="p-col-12 p-md-6 p-lg-3">
            <p-dropdown [style]="{width: '100%',border:'none', borderBottom: '2px solid #47bfd4'}"
                        inputId="dropdown" placeholder="{{ 'SELECT_LOCATION' | translate}}"
                        (onChange)="parameters.location = $event.value;"
                        appendTo="body"
                        [options]="locations" name="movementLocation" [(ngModel)]="parameters.location"
                        optionLabel="name" optionValue="id">
            </p-dropdown>

          </div>
          <div class="p-col-12 p-md-6 p-lg-2">
            <p-button label="{{'SEARCH' | translate}}" type="submit"></p-button>
            <p-button label="{{'RESET' | translate}}" type="reset" (onClick)="reset()" style="margin-left: 10px"></p-button>
          </div>
        </div>
      </form>
  <div class="p-grid">
    <div class="p-col-12" style="overflow-x: auto;">
      <p-table [value]="invoices" [lazy]="true"  (onLazyLoad)="load($event, 'search')"
               [paginator]="true"
               [rows]="20" [showCurrentPageReport]="true"  [totalRecords]="total"
      >
        <ng-template pTemplate="header">
          <tr>
            <th [style]="{width:'30%'}">{{ 'SUPPLIER'| translate }}</th>
            <th [style]="{width:'10%'}">{{ 'LOCATION'| translate }}</th>
            <th [style]="{width:'7%'}">{{ 'CODE'| translate }}</th>
            <th [style]="{width:'10%'}">{{ 'DOCUMENT_DATE'| translate }}</th>
            <th [style]="{width:'10%'}">{{ 'DOCUMENT_NUMBER'| translate }}</th>
            <th [style]="{width:'10%'}">{{ 'QUANTITY'| translate }}</th>
            <th [style]="{width:'10%'}">{{ 'UNIT_PRICE'| translate }}</th>
            <th [style]="{width:'10%'}">{{ 'TOTAL'| translate }}</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
          <tr>
            <td>{{ row.contact }}</td>
            <td>{{ row.location }}</td>
            <td>{{ row.code }}</td>
            <td >{{ row.documentDate.date | date: 'Y-mm-dd'}}</td>
            <td style="text-align: right">{{ row.documentNumber }}</td>
            <td style="text-align: right">{{ row.quantity  | number : '1.2-2'}} {{ row.unit}}</td>
            <td style="text-align: right">{{ row.unitPrice  | countryCurrency}}</td>
            <td style="text-align: right">{{ row.quantity  * row.unitPrice  | countryCurrency}}</td>
           </tr>
        </ng-template>
      </p-table>

    </div>
  </div>
</p-card>
<p-dialog [(visible)]="staticsDisplay">
  <h4>{{ stockName }}</h4>
  <p-chart type="bar" [data]="data" [options]="chartOptions" width="700px" height="400px"></p-chart>
</p-dialog>
